import React, { Component } from "react";
import { connect } from "react-redux";
import TLDRColorPicker from "../tldrColorPicker/TLDRColorPicker";

export class GradientColor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      color: props.color,
    };
  }

  render() {
    const { color } = this.state;
    const { brandKit, canvas } = this.props;
    const { title, palette } =
      brandKit.brandkitPayload.length > 0 && brandKit.brandkitPayload[0];

    return (
      <TLDRColorPicker
        color={color}
        callback={(action, bk) => this.onColorChangeComplete(action, bk)}
        showBrandkitPaletteColors={brandKit.brandkitPayload.length > 0}
        brandkitTitle={title}
        brandkitPalette={palette && palette.length > 0 && palette[0]}
        gradientsColorPicker={true}
        showColorInput={false}
        iscircularpicker="true"
        canvas={canvas}
        menuButtonExtraStyling={{
          borderRadius: "50%",
          border: "2px solid white",
          height: "20px",
          width: "20px",
          margin: "0 5px 0 0",
        }}
      />
    );
  }

  onColorChangeComplete = (action, bk) => {
    const { color } = this.state;
    if (color === bk) return;

    this.setState(
      {
        ...this.state,
        color: bk,
      },
      () => {
        this.props.changeSelectedColor(bk, color);
        this.props.applyGradient("push");
      }
    );
  };
}

GradientColor.propTypes = {};

const mapStateToProps = (state) => ({
  brandKit: state.brandKit,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GradientColor);
